<iris-card>
  <div class="card-header" data-dd-privacy="allow">
    <iris-button
      [disabled]="!isEligible"
      ariaLabel="Open Rcopia Modal"
      (click)="openRcopiaModal()"
      [type]="IrisButtonTypes.PRIMARY"
      data-test="btn-open-rcopia-prescriptions"
    >
      Write/Manage prescriptions
    </iris-button>
    <p *ngIf="!isEligible" data-test="msg-not-eligible">
      Client registration is not complete.
    </p>
  </div>
</iris-card>
